import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargarCatalogos, cargarCatalogos_Otros, cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { validarCampoString } from '../../funciones_globales/utils'
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormVen12  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            periodos: [],
            periodo_sel: undefined,
            meses: [],
            mes_sel: null,
            bodegas: [],
            bodega_sel: null,
            lineas: [],
            linea_sel: null,
            subLinea_sel: null,
            marca_sel: null,
            tipoCompra: null,
            periodosHist: 1,
            vehiculosAplic: '',
            conIva: false
        };
        
        this.limpiar = this.limpiar.bind(this);        
        this.generarReporteListaPrecios = this.generarReporteListaPrecios.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    getOptions_TiposCompra(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('TIPOPRECIO', input, callback)
        }
    }

    getOptions_Marcas(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('LINEA', input, callback)
        }
    }

    componentDidMount(){
        Promise.all([
            cargarCatalogos('BODEGA'),
            cargarCatalogos_Otros('MESES'),
            cargarCatalogos('FORMA'),
            this.props.generar_LogAuditoriaIngresoForm('0412')
         ])
        .then(([ bodegas, meses, lineas ]) => {
            let fechaProceso = getFechaProcesoPorModulo('04');
            if (validarCampoString(fechaProceso, 10)){
                let periodoActual = formatearNumeroEntero(fechaProceso.toString().split('/')[2]);
                let periodoTmp = periodoActual;
                let catalogoPeriodos = [];   

                while (periodoTmp>(periodoActual-this.state.periodosHist)){
                    catalogoPeriodos.push(periodoTmp);
                    periodoTmp-=1;
                }

                let mesActual = fechaProceso.toString().split('/')[1];
                
                this.setState({ bodegas,
                                bodega_sel: '01', 
                                periodos: catalogoPeriodos,
                                periodo_sel: periodoActual,
                                meses,
                                mes_sel: mesActual,
                                lineas
                            });
            }
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0412');
    }

    getOptions_Sublineas(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('SUBLINEA', input, callback)
        }
    }

    generarReporteListaPrecios(tipoRpt){        
        try {
            let urlReportWithParams='';

            if (!validarCampoString(this.state.periodo_sel, 4)){
                alert('No ha seleccionado un Período válido.');
                return;
            }
            if (!validarCampoString(this.state.mes_sel, 2)){
                alert('No ha seleccionado un Mes válido.');
                return;
            }
            if (!validarCampoString(this.state.bodega_sel, 2)){
                alert('No ha seleccionado una Bodega válida.');
                return;
            }

            urlReportWithParams += `&param1=${this.state.periodo_sel}`;
            urlReportWithParams += `&param2=${this.state.bodega_sel}`;
            urlReportWithParams += `&param3=${this.state.mes_sel}`;

            if (this.state.subLinea_sel != null){
                urlReportWithParams += `&param4=${this.state.subLinea_sel.value}`;
            }

            if (this.state.tipoCompra_sel != null){
                urlReportWithParams += `&param5=${this.state.tipoCompra_sel.value}`;
            }

            if (this.state.marca_sel != null){
                urlReportWithParams += `&param6=${this.state.marca_sel.value}`;
            }

            if (validarCampoString(this.state.vehiculosAplic, 1, 20)){
                urlReportWithParams += `&param7=${this.state.vehiculosAplic}`;
            }

            if (this.state.linea_sel != null){
                urlReportWithParams += `&param8=${this.state.linea_sel.value}`;
            }

            urlReportWithParams += `&param9=${this.state.conIva?'S':'N'}`;

            if(tipoRpt==='PDF'){
                urlReportWithParams = `&rpt=37`.concat(urlReportWithParams);
                visualizarReporteEnPdf(urlReportWithParams);
            }else{
                urlReportWithParams = `&rpt=88`.concat(urlReportWithParams);
                generarReporteEnExcel(urlReportWithParams);
            }
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04');
        if (validarCampoString(fechaProceso, 10)){            
            let periodoActual = formatearNumeroEntero(fechaProceso.toString().split('/')[2]);

            let mesActual = fechaProceso.toString().split('/')[1];
            this.setState({ periodo_sel: periodoActual,
                            mes_sel: mesActual,
                            bodega_sel: '01',
                            linea_sel: null,
                            subLinea_sel: null,
                            marca_sel: null,
                            tipoCompra: null,
                            vehiculosAplic: '',
                            conIva: false
                        });
        }else{
            this.setState({ bodega_sel: '01',
                            linea_sel: null,
                            subLinea_sel: null,
                            marca_sel: null,
                            tipoCompra: null,
                            vehiculosAplic: '',
                            conIva: false
                         });
        }        
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Lista de Precios de Artículos</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Período:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <select name='periodo_sel' value={this.state.periodo_sel} onChange={this.handleInputChange} className='form-control input-sm'>
                                {
                                    this.state.periodos.map((periodo, i)=>{
                                        return <option key={i} value={periodo}>{periodo}</option>
                                    })
                                }
                            </select>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Mes:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3'>
                            <ReactSelect options={ this.state.meses } value={this.state.mes_sel} func_onChange={(value)=>{this.setState({mes_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Bodega:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <ReactSelect options={ this.state.bodegas } value={this.state.bodega_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({bodega_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Marca:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <ReactSelectAsync value={this.state.marca_sel} func_loadOptions={this.getOptions_Marcas} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({marca_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Categoría:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <ReactSelectAsync value={this.state.tipoCompra_sel} func_loadOptions={this.getOptions_TiposCompra} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({tipoCompra_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Linea:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <ReactSelect options={ this.state.lineas } value={this.state.linea_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({linea_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Sublínea:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <ReactSelectAsync value={this.state.subLinea_sel} func_loadOptions={this.getOptions_Sublineas} func_onChange={(value)=>{this.setState({subLinea_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Vehículos Aplic.:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5'>
                            <InputText name='vehiculosAplic' value={this.state.vehiculosAplic} onChange={this.handleInputChange} maxLength='20'/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Incluir IVA:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1'>
                            <input type='checkbox' name='conIva' checked={this.state.conIva} onChange={this.handleInputChange}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' onClick={()=>{this.generarReporteListaPrecios('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>
                                <button type='button' className='btn btn-success btn-sm' onClick={()=>{this.generarReporteListaPrecios('EXCEL')}}><i className="fa fa-file-excel-o fa-lg" aria-hidden="true"/> Generar Excel</button>
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormVen12);